/**
 * @file 所有api集合
 */
// 线上地址
const host1 = "https://sso.cnecop.cn";
// const host2 = 'https://sso.cnecop.cn';

// 测试地址
const host2 = "https://sso.cnecop.cn";
// const host2 = 'http://11ur22ipei4l.ngrok.xiaomiqiu123.top';
// const host2 = 'http://11ur22ipei4l.ngrok.xiaomiqiu123.top';

export default {
  lujingPic: "https://monitoring-system-images.oss-cn-shanghai.aliyuncs.com/",
  host: host2,
  // 登录
  login: {
    api: host1 + "/connect/token",
  },
  device: {
    // api: host2 + '/api/v2/AD_Atmosphere_Info',
    // infos: host2 + '/api/v2/AD_Atmosphere_Info',
    api: host2 + "/api/v2/deviceInfos",
    infos: host2 + "/api/v2/deviceInfos",
    detail: host2 + "/api/v2/devicedatas",
    images: host2 + "/api/v2/imageinfos",
    upload: host2 + "/api/v2/DeviceDatas/Upload",
    attachDevice: host2 + "/api/v2/AttachDeviceInfos",
    attachDeviceTypes: host2 + "/api/v2/AttachDeviceTypes",
  },
  Spectrum: {
    api: host2 + "/api/v2/AD_Spectrum_Infos",
    infos: host2 + "/api/v2/AD_Spectrum_Infos",
  },
  Phenology: {
    api: host2 + "/api/v2/AD_Phenology_Infos",
    infos: host2 + "/api/v2/AD_Phenology_Infos",
  },
  PhenologyPlus: {
    api: host2 + "/api/v2/AD_PhenologyPlus_Infos",
    infos: host2 + "/api/v2/AD_PhenologyPlus_Infos",
  },
  MultiPhenology: {
    api: host2 + "/api/v2/AD_MultiPhenology_Infos",
    infos: host2 + "/api/v2/AD_MultiPhenology_Infos",
  },
  Coverage: {
    api: host2 + "/api/v2/AD_Coverage_Infos",
    infos: host2 + "/api/v2/Coverage_Infos",
  },
  Canopy: {
    api: host2 + "/api/v2/AD_Canopy_Infos",
    infos: host2 + "/api/v2/Canopy_Infos",
  },
  CoveragePlus: {
    api: host2 + "/api/v2/AD_CoveragePlus_Infos",
    infos: host2 + "/api/v2/CoveragePlus_Infos",
  },
  IntelliVision: {
    api: host2 + "/api/v2/AD_IntelliVision_Infos",
    infos: host2 + "/api/v2/IntelliVision_Infos",
  },
  AudioPattern: {
    api: host2 + "/api/v2/AD_AudioPattern_Infos",
    infos: host2 + "/api/v2/AudioPattern_Infos",
  },
  Atmosphere: {
    infos: host2 + "/api/v2/AD_Atmosphere_Infos",
  },
  Camera: {
    api: host2 + "/api/v2/AD_Camera_Infos",
    infos: host2 + "/api/v2/AD_Camera_Infos",
  },
  worm: {
    api: host2 + "/api/v2/AD_Insect_Infos",
    datas: host2 + "/api/v2/AD_Insect_Data",
    types: host2 + "/api/v2/AD_Insect_Types",
  },
  wormSeduce: {
    api: host2 + "/api/v2/AD_InsectSeduce_Infos",
    datas: host2 + "/api/v2/AD_InsectSeduce_Data",
    types: host2 + "/api/v2/AD_InsectSeduce_Types",
    lureInfos: host2 + "/api/v2/AD_InsectSeduce_LureInfos",
  },
  animal: {
    // AD_AnimalCamera_
    api: host2 + "/api/v2/AD_AnimalCamera_Infos",
    datas: host2 + "/api/v2/AD_AnimalCamera_Data",
    types: host2 + "/api/v2/AD_AnimalCamera_Types",
  },
  userInfo: {
    api: host1 + "/odata/userinfoes",
  },
  warnings: {
    api: host2 + "/api/v2/alarminfos",
    types: host2 + "/api/v2/alarmtypes",
  },
  phenology: {
    api: host2 + "/api/v2/PhenologyInfos",
  },
  coverage: {
    api: host2 + "/api/v2/coverage",
  },
  stationRealtime: {
    stations: "/api/v2/stationRealtime/stations",
    stationDetail: "/api/v2/stationRealtime/stationDetail",
  },
  // 模板
  templates: {
    api: host2 + "/api/v2/AD_Atmosphere_Templates",
  },
  //预警信息
  deviceAlarms: {
    api: host2 + "/api/v2/AttachDeviceAlarms",
  },
};
